import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import LegalDocsComp from './LegalDocsComp';

function LegalDocs() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <LegalDocsComp />
      </div>
    </div>
  );
}

export default LegalDocs;
